import React from 'react';
import { useUrlParams } from '../../hooks';
import PayAmigoForm from '../../components/payAmigoForm';
import { PaymentType } from '../../api/payamigo';

import './pay-amigo.scss';

interface IPayAmigoProps {
  paymentType?: PaymentType;
}

const PayAmigo: React.FC<IPayAmigoProps> = ({ paymentType = PaymentType.Deposit }) => {
  const { sessionId, paymentCurrencyCode } = useUrlParams();

  return (
    <div className="pay-amigo-page">
      <PayAmigoForm 
        existingSessionId={sessionId}
        coin={paymentCurrencyCode}
        paymentType={paymentType}
      />
    </div>
  );
};

export default PayAmigo;

